import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import { TextField, Tooltip, Typography } from '@mui/material';
import { action, computed, makeObservable, runInAction, when } from 'mobx';
import { inject, observer } from 'mobx-react';
import React from 'react';
import NumeroProcessoUtil from '../../util/NumeroProcessoUtil';
import ReactComponent from '../ReactComponent';

class SequenciaPreferencia extends ReactComponent {
    timeoutSalvar;
    refCampo;

    constructor(props) {
        super(props);

        makeObservable(this, {
            registro: computed,
            handleChangeSequencial: action,
            salvarSequencial: action,
            handleOnFocus: action,
            handleOnBlur: action
        });

        this.refCampo = React.createRef();
    }

    componentDidMount() {
        this.colocarFocoCampo();
    }

    componentDidUpdate(prevProps) {
        super.componentDidUpdate(prevProps);
        this.colocarFocoCampo();
    }

    colocarFocoCampo() {
        if (
            this.sessaoStore.campoFocoPosOrdenacao === 'SequenciaPreferencia' &&
            this.sessaoStore.numeroProcessoFocoPosOrdenacao === this.registro.numeroProcesso
        ) {
            setTimeout(() => {
                if (!this.registro.rendered) {
                    runInAction(() => {
                        this.salaSessaoStore.processoScroll = this.registro;
                    });
                }

                when(
                    () => {
                        return this.refCampo.current;
                    },
                    () => {
                        return this.refCampo.current.focus();
                    }
                );
            }, 1);
        }
    }

    get registro() {
        return this.observableProps.registro;
    }

    handleChangeSequencial = (event) => {
        let sequencial = event.target.value;
        if (sequencial === '' || NumeroProcessoUtil.isNumeroInteiro(sequencial)) {
            this.registro.informacaoProcessoSalaSessao.sequenciaPreferencia = sequencial;
            if (this.timeoutSalvar) {
                clearTimeout(this.timeoutSalvar);
            }
            this.timeoutSalvar = setTimeout(this.salvarSequencial.bind(this, sequencial), 1000);
        }
    };

    salvarSequencial = (sequencial) => {
        this.salaSessaoStore
            .salvarSequenciaPreferenciaArbitraria(this.registro, sequencial)
            .then(() => this.salaSessaoStore.ordenarProcessos());
    };

    handleOnFocus = () => {
        this.sessaoStore.numeroProcessoFocoPosOrdenacao = this.registro.numeroProcesso;
        this.sessaoStore.campoFocoPosOrdenacao = 'SequenciaPreferencia';
    };

    handleOnBlur = () => {
        if (this.sessaoStore.numeroProcessoFocoPosOrdenacao === this.registro.numeroProcesso) {
            this.sessaoStore.numeroProcessoFocoPosOrdenacao = undefined;
            this.sessaoStore.campoFocoPosOrdenacao = undefined;
        }
    };

    render() {
        return (
            <Tooltip
                title={
                    <>
                        <Typography
                            display="inline"
                            fontSize="14px"
                            fontWeight="bold"
                            color="inherit"
                        >
                            Sequencial
                        </Typography>
                        <FormatListNumberedIcon
                            style={{ marginLeft: '4px', verticalAlign: 'middle', fill: 'orange' }}
                        />
                    </>
                }
            >
                <TextField
                    id={'idSequencial' + this.registro.numeroProcesso}
                    variant="outlined"
                    value={
                        this.registro.informacaoProcessoSalaSessao.sequenciaPreferencia > -9999
                            ? this.registro.informacaoProcessoSalaSessao.sequenciaPreferencia
                            : ''
                    }
                    disabled={this.registro.necessitaImportacaoSalaSessao}
                    onChange={this.handleChangeSequencial}
                    onFocus={this.handleOnFocus}
                    onBlur={this.handleOnBlur}
                    inputRef={this.refCampo}
                    slotProps={{
                        htmlInput: {
                            maxLength: 3,
                            style: { width: '28px', height: '22px', fontSize: '14px', padding: '2px 0px 2px 5px' }
                        }
                    }}
                />
            </Tooltip>
        );
    }
}

export default inject('stores')(observer(SequenciaPreferencia));
